<template lang="pug">
  .product-list-table-wrapper.mb-3(data-slideout-ignore v-if="products")
    .product-list-table-container(v-dragscroll.x="!touchDevice")
      table.product-list-table#product-list-table
        thead#table-header
          tr
            th Picture
            th Description
            th Pack/Multiples
            th Add to cart
            th(
              v-for="column in config.columns" :key="column" v-if="config.columns" @click="toggleSort(column)"
              v-bind:class="{'active': configData.sort.column === column }"
            )
              .row.no-gutters
                .col
                  | {{ getSpecLabelByKey(column) }}
                .col-auto
                  .sort-icon.ml-3
                    font-awesome-icon(:icon=['far', 'sort-amount-down-alt'] v-if="configData.sort.direction === 'asc' || configData.sort.column !== column")
                    font-awesome-icon(:icon=['far', 'sort-amount-down'] v-if="configData.sort.column === column && configData.sort.direction === 'desc'")
        tbody
          tr.product-list-row(v-for="product in products" :key="product.id")
            td(data-no-dragscroll)
              .table-cell.d-flex.flex-column.justify-content-center(style="width: 115px")
                router-link(:to='product.permalink', :title="'ดูสินค้า ' + product.name")
                  img(:src="'https://www.sparkinter.com/imageproduct/' + product.item_code + '.jpg'" v-if="product.item_code")
            td(data-no-dragscroll)
              .table-cell(style="width: 280px")
                router-link(:to='product.permalink', :title="'ดูสินค้า ' + product.name")
                  h3.product-list__item-title {{ product.name }}
                .product-list__item-description
                  ul
                    li(v-if="product.item_code") Item Code: {{ product.item_code }}
                    li(v-if="product.brand") Brand: {{ product.brand }}
                .d-flex.flex-row.align-items-center.mt-2
                  add-to-wishlist-button.d-inline-block(:item-code="product.item_code")
                  add-to-compare-button.d-inline-block.ml-3(:item="product")
            td(data-no-dragscroll)
              .table-cell(style="width: 165px")
                table.table.table--price-ranges
                  thead
                    tr
                      th Qty
                      th THB
                  tbody
                    tr(v-for="price in product.price_ranges")
                      td(v-if="price.maximum_quantity < 99999999") {{ price.minimum_quantity | numeral }} - {{ price.maximum_quantity | numeral }}
                      td(v-if="price.maximum_quantity > 99999999") {{ price.minimum_quantity | numeral }}+
                      td
                        span(v-if="price.price < 1000") {{ price.price | numeral('0,0.00') }} ฿
                        span(v-if="price.price >= 1000 && price.price < 10000") {{ price.price | numeral('0,0.0') }} ฿
                        span(v-if="price.price >= 10000") {{ price.price | numeral('0,0') }} ฿
            td(data-no-dragscroll)
              .table-cell(style="width: 145px")
                add-to-cart-button(
                  :product="product"
                  :disabled="!product"
                  button-classes="btn btn-sm btn-primary btn-block btn--add-to-cart"
                  v-if="product"
                  size="sm"
                )
            td(v-for="column in config.columns" :key="column" v-if="config.columns")
              .table-cell.table-cell--sm
                span.product-list__item-spec {{ product.specs ? product.specs[column] : '' }}
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import AddToWishlistButton from '../buttons/shop/AddToWishlistButton.vue';
import notify from '../notify';
import ConversionManager from '../../mixins/ConversionManager';
import ProductCategorySpecs from "../../pages/shop/product/ProductCategorySpecs";
import AddToCartButton from "../buttons/shop/AddToCartButton";
import AddToCompareButton from "../buttons/shop/AddToCompareButton";
import { dragscroll } from 'vue-dragscroll'

export default {
  components: {
    AddToCartButton,
    AddToWishlistButton,
    AddToCompareButton,
    VuePerfectScrollbar
  },
  directives: {
    dragscroll
  },
  mixins: [ConversionManager],
  props: {
    type: {
      type: String,
      default: 'vertical',
    },
    products: {
      type: Array,
      required: true,
    },
    config: {
      type: Object,
      default: () => {}
    },
    filters: {
      type: Object,
    }
  },
  data() {
    let sort = {};
    if (!_.isEmpty(this.filters.sort)) {
      const sortData = this.filters.sort.split(":");
      sort = { column: sortData[0], direction: sortData[1] }
    }
    return {
      touchDevice: ('ontouchstart' in window || navigator.msMaxTouchPoints) || false,
      quantity: 1,
      configData: {
        sort,
      }
    };
  },
  created() {
    this.configData = { ...this.configData, ...this.config }
  },
  mounted() {
    Vue.nextTick(() => {
      $("#table-fixed-header").html('');
      const tableOffset = $("#product-list-table").offset().top;
      const $header = $("#product-list-table > thead#table-header").clone();
      const $fixedHeader = $("#table-fixed-header").append($header);

      $(window).bind("scroll", function() {
        const offset = $(this).scrollTop() - 300;

        if (offset >= tableOffset && !$fixedHeader.hasClass("is-active")) {
          $fixedHeader.addClass('is-active');
        }
        else if (offset - 300 < tableOffset) {
          $fixedHeader.removeClass('is-active');
        }
      });

      $(".product-list-table-container").scroll(function () {
        $("#table-fixed-header-wrapper ").scrollLeft(this.scrollLeft);
      });
    });
  },
  methods: {
    async onAddToCart() {
      if (parseInt(this.quantity, 10) <= 0) {
        notify.message(this, { title: Lang.get('alerts.frontend.general.select_at_lease_one'), text: false }, 'danger');
        return;
      }
      try {
        const { data } = await this.$store.dispatch('cart/add', {
          cart_id: this.$store.getters['cart/id'],
          item_code: this.product.item_code,
          quantity: this.quantity,
          redirect: false,
        });
        console.log(data);
        this.trackEvent('Conversion', 'Buttons', 'Buy Now', 'Product List Item (Buy Now)', 1);
        notify.success(this, { title: Lang.get('alerts.frontend.general.added_to_cart'), text: false });
      } catch (e) {
        notify.clean(this).then(() => notify.errors(this, e));
      }
    },
    getSpecLabelByKey(key) {
      if (typeof this.dataFilters !== 'undefined') {
        if (typeof ProductCategorySpecs[this.dataFilters.category] !== 'undefined') {
          if (typeof ProductCategorySpecs[this.dataFilters.category].labels[key] !== 'undefined') {
            return ProductCategorySpecs[this.dataFilters.category].labels[key];
          }
        }
      }
      return key.replace("_", " ");
    },
    toggleSort(column) {
      let direction = 'desc';
      if (typeof this.configData.sort !== 'undefined') {
        if (typeof this.configData.sort.column !== 'undefined'
          && this.configData.sort.column === column && this.configData.sort.direction === 'desc') {
          direction = 'asc';
        }
      }
      this.$emit('sorted', { column, direction });
    }
  },
};
</script>
